(() => {
  if (window.__sgAiSearchSubmitFix) return;
  window.__sgAiSearchSubmitFix = true;

  const ownScript = document.currentScript?.src || [...document.scripts].find(s => /sg-ai-search-submit-fix\.js/.test(s.src))?.src || '';
  const assetBase = ownScript ? new URL('.', ownScript) : null;
  const assetUrl = (name) => assetBase ? new URL(name, assetBase).toString() : name;

  function ensureStyle(name) {
    if ([...document.styleSheets].some(s => String(s.href || '').includes(`/${name}`)) || document.querySelector(`link[data-sg-asset="${name}"]`)) return;
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = assetUrl(name);
    link.dataset.sgAsset = name;
    document.head.appendChild(link);
  }

  function loadScript(name) {
    if ([...document.scripts].some(s => String(s.src || '').includes(`/${name}`))) return Promise.resolve();
    return new Promise((resolve) => {
      const script = document.createElement('script');
      script.src = assetUrl(name);
      script.dataset.sgAsset = name;
      script.onload = resolve;
      script.onerror = resolve;
      document.head.appendChild(script);
    });
  }

  async function bootCommerce() {
    ensureStyle('sg-commerce-v2.css');
    if (!window.SGCommerce) await loadScript('sg-commerce-core.js');
    await loadScript('sg-commerce-results.js');
    await loadScript('sg-commerce-assistant.js');
    await loadScript('sg-commerce-productfinder-expansion.js');
  }
  bootCommerce().catch(() => {});

  // The base asset currently uses AbortSignal.timeout(1800). Give the deep
  // enrichment a practical budget; fast Shopify results are rendered first.
  if (window.AbortSignal && typeof window.AbortSignal.timeout === 'function') {
    const nativeTimeout = window.AbortSignal.timeout.bind(window.AbortSignal);
    window.AbortSignal.timeout = (ms) => nativeTimeout(ms === 1800 ? Math.max(ms, 5000) : ms);
  }

  function retriggerDebouncedSearch(form) {
    const input = form.querySelector('#SgAiSearchInput');
    if (!input) return;
    const q = input.value.trim();
    if (!q) return;
    input.dispatchEvent(new Event('input', { bubbles: true }));
  }

  document.addEventListener('submit', (event) => {
    const form = event.target?.closest?.('#SgAiSearchOverlay [data-sg-search-form]');
    if (!form) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    retriggerDebouncedSearch(form);
  }, true);
})();
